module.exports = __webpack_public_path__ + "img/right.7b80ce24.svg";